// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import format from 'date-fns/format';
import DatePicker from 'react-datepicker';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import MarkBillAsPaidHeader from './components/MarkBillAsPaidHeader';
import { MARK_AS_PAID_STYLES } from './styles';
import {
  getFutureDateFromSpecificDate,
  getPriorDateFromSpecificDate,
} from '../../../../../../../../helpers/datesAndTime.helper';
import { ReactComponent as IconRedError } from '../../../../../../../../assets/svg/shared/icon-red-error.svg';
import { ReactComponent as IconCalendar } from '../../../../../../../../assets/icons/svg/shared/ic-shared-calendar.svg';
import { ReactComponent as IconArrowDown } from '../../../../../../../../assets/billpay/arrow-down-grey.svg';
import { ReactComponent as IconArrowUp } from '../../../../../../../../assets/billpay/arrow-up-blue.svg';
import { useStore } from '../../../../../../../../store';
import { AVAILABLE_BILL_MODALS, PAYMENT_METHODS_DROPDOWN_OPTIONS } from '../../consts';
import { markBillAsPaidAPIAction } from './api/MarkBillAsPaidAPI';
import { BILLS_STATUSES } from '../../../../../../consts';
import MarkBillAsPaidSuccess from '../../../Toasts/MarkBillAsPaidSuccess';

interface IMarkBillAsPaidProps {
  amount: number;
  billId: string;
  onClose: () => void;
}

type SelectedPaymentMethodType = {
  value: string;
  text: string;
  icon: any;
};

const defaultSelectedPaymentMethod = {
  value: '',
  text: 'COMPONENTS.MARK_AS_PAID.PAYMENT_METHOD_DROPDOWN_DEFAULT',
  icon: '',
};

const MarkBillAsPaid = ({ amount, billId, onClose }: IMarkBillAsPaidProps) => {
  const user = useStore((state) => state.user);
  const getPersonalAccount = useStore((state) => state.getPersonalAccount);
  const removeBillFromList = useStore((state) => state.removeBillFromList);
  const setBillError = useStore((state) => state.setBillError);
  const showBillDetailsModal = useStore((state) => state.showBillDetailsModal);
  const setShowBillDetailsModal = useStore((state) => state.setShowBillDetailsModal);
  const setSelectedBill = useStore((state) => state.setSelectedBill);
  const { accountExternalId } = getPersonalAccount();
  const { customerId } = user;
  const setActiveBillModal = useStore((state) => state.setActiveBillModal);
  const { t } = useTranslation();
  const [showDatePicker, setShowDatePicker] = useState<boolean>(false);
  const [selectedDate, setSelectedDate] = useState<Date | undefined>();
  const [selectedDateError, setSelectedDateError] = useState<string>('');
  const [showPaymentMethodsDropdown, setShowPaymentMethodsDropdown] = useState<boolean>(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    useState<SelectedPaymentMethodType>(defaultSelectedPaymentMethod);
  const [selectedPaymentMethodError, setSelectedPaymentMethodError] = useState<string>('');

  useEffect(() => {
    if (selectedDate) {
      setSelectedDateError('');
    }
  }, [selectedDate]);

  useEffect(() => {
    if (selectedPaymentMethod.value) {
      setSelectedPaymentMethodError('');
    }
  }, [selectedPaymentMethod]);

  const handleDateInputClick = () => {
    setShowDatePicker(!showDatePicker);
  };

  const handleDateSelected = (date: Date) => {
    setSelectedDate(date);
    setShowDatePicker(false);
  };

  const handlePaymentMethodOptionClick = (option: SelectedPaymentMethodType) => {
    setSelectedPaymentMethod(option);
    setShowPaymentMethodsDropdown(false);
  };

  const handlePaymentMethodsDDClick = () => {
    setShowPaymentMethodsDropdown(!showPaymentMethodsDropdown);
  };
  const handleSubmit = async () => {
    if (selectedDate && selectedPaymentMethod?.value) {
      setActiveBillModal(AVAILABLE_BILL_MODALS.SPINNER);
      try {
        const response = await markBillAsPaidAPIAction(
          customerId,
          accountExternalId,
          billId,
          selectedDate,
          selectedPaymentMethod.value,
        );
        setShowBillDetailsModal(false);
        setActiveBillModal(AVAILABLE_BILL_MODALS.NONE);
        if (response?.status === BILLS_STATUSES.PAID) {
          toast(<MarkBillAsPaidSuccess />, {
            position: toast.POSITION.TOP_CENTER,
            bodyClassName: 'p-0',
            className: 'w-[350px] h-[60px] bg-bw08 p-0',
          });
          if (showBillDetailsModal) setSelectedBill(billId, response);
          setTimeout(() => {
            removeBillFromList(BILLS_STATUSES.PENDING, billId);
          }, 0);
        }
      } catch (error: any) {
        setBillError(error);
        setActiveBillModal(AVAILABLE_BILL_MODALS.ERROR);
      }
    } else {
      if (!selectedDate) setSelectedDateError(t('COMPONENTS.MARK_AS_PAID.ERRORS.INVALID_DATE'));
      if (!selectedPaymentMethod?.value) setSelectedPaymentMethodError(t('COMPONENTS.MARK_AS_PAID.ERRORS.INVALID_PAYMENT_METHOD'));
    }
  };

  const renderPaymentTimeInput = () => (
    <div className='relative bills-datepicker' data-testid='BillsHub__Modal__Mark-as-Paid'>
      <div
        className={`${MARK_AS_PAID_STYLES.INPUT_STYLE} ${showDatePicker ? 'border-action03' : ' border-bw06'} mt-[20px] ${selectedDateError ? 'border-red02' : 'mb-[20px]'}`}
        onClick={handleDateInputClick}
        onKeyDown={handleDateInputClick}
        role='button'
        tabIndex={0}
        data-testid='billsHub-markAsPaid-selectedDate'
      >
        <div className={`${MARK_AS_PAID_STYLES.INPUT_TEXT_STYLE}`}>{t('COMPONENTS.MARK_AS_PAID.LABEL_DATE')}</div>
        <div className='font-metricR text-bw08'>
          {selectedDate ? format(selectedDate, 'MMM dd, yyyy') : 'DD/MM/YY'}
          <IconCalendar
            width={24}
            height={24}
            className={`${MARK_AS_PAID_STYLES.ICON} ${showDatePicker ? 'text-action03' : 'text-bw08'}`}
          />
        </div>
      </div>
      {selectedDateError && (
        <div className={MARK_AS_PAID_STYLES.ERROR_WRAPPER} data-testid='billsHub-markAsPaid-errorDate'>
          <IconRedError />
          <div className={MARK_AS_PAID_STYLES.ERROR_TEXT}>{t(selectedDateError)}</div>
        </div>
      )}
      {showDatePicker && (
        <div className={MARK_AS_PAID_STYLES.DATE_PICKER_WRAPPER} data-testid='billsHub-markAsPaid-datePicker'>
          <DatePicker
            onChange={handleDateSelected}
            onClickOutside={() => setShowDatePicker(false)}
            selected={selectedDate}
            minDate={getPriorDateFromSpecificDate(366, new Date())}
            maxDate={getFutureDateFromSpecificDate(366, new Date())}
            dropdownMode='select'
            showMonthDropdown
            showYearDropdown
            inline
          />
        </div>
      )}
    </div>
  );
  const renderPaymentMethodInput = () => (
    <div className='relative'>
      <div
        data-testid='BillPayHub-markAsPaid-selectedPaymentMethod'
        className={`${MARK_AS_PAID_STYLES.INPUT_STYLE} ${showPaymentMethodsDropdown ? 'border-action03' : ' border-bw06'} ${selectedPaymentMethodError ? 'border-red02' : ''}`}
        onClick={handlePaymentMethodsDDClick}
        onKeyDown={handlePaymentMethodsDDClick}
        role='button'
        tabIndex={0}
      >
        <div className={`${MARK_AS_PAID_STYLES.INPUT_TEXT_STYLE}`}>
          {t('COMPONENTS.MARK_AS_PAID.LABEL_PAYMENT_METHOD')}
        </div>
        <div className='font-metricR text-bw08'>{t(selectedPaymentMethod.text)}</div>
        {showPaymentMethodsDropdown ? (
          <IconArrowUp className={MARK_AS_PAID_STYLES.ICON} />
        ) : (
          <IconArrowDown className={MARK_AS_PAID_STYLES.ICON} />
        )}
      </div>
      {selectedPaymentMethodError && (
        <div data-testid='BillPayHub-markAsPaid-errorPaymentMethod' className='my-[3px] flex items-center'>
          <IconRedError />
          <div className='ml-[4px] font-metricRMedium text-red02 text-sm'>{t(selectedPaymentMethodError)}</div>
        </div>
      )}
      {showPaymentMethodsDropdown && (
        <div
          data-testid='Bill-Pay-Hub-markAsPaid-paymentMethodDropdown'
          className='absolute rounded-lg left-0 top-[55px] max-h-max bottom-[-242px] w-fit shadow-chatBotButton bg-bw00 min-w-[260px]'
        >
          <ul>
            {PAYMENT_METHODS_DROPDOWN_OPTIONS.map((option) => {
              const Icon = option.icon;
              return (
                <li
                  data-testid={`paymentMethod-${option.value.toLowerCase()}`}
                  className='w-[516px] h-[42px] hover:cursor-pointer hover:bg-bw02 last:rounded-b-lg first:rounded-t-lg border-b-[1px] border-bw03'
                  key={`payment_method_${option.value}`}
                >
                  <button
                    className='w-full h-full flex items-center pl-[15px] py-[9px] '
                    type='button'
                    onClick={() => handlePaymentMethodOptionClick(option)}
                  >
                    <Icon className='w-[18px] h-[18px]' />
                    <div className='font-metricR text-bw08 ml-[10px] text-md leading-4'>{t(option.text)}</div>
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
  return (
    <div className={MARK_AS_PAID_STYLES.WRAPPER} data-testid='billsHub-markAsPaid-main'>
      <div>
        <MarkBillAsPaidHeader amount={amount} />
        {renderPaymentTimeInput()}
        {renderPaymentMethodInput()}
      </div>
      <div className='flex justify-end'>
        <LiliButton
          id='invoiceHub-markAsPaid-buttonCancel'
          testId='invoiceHub-markAsPaid-buttonCancel'
          onClick={onClose}
          type={LiliButtonType.SECONDARY}
          title={t('COMPONENTS.MARK_AS_PAID.BUTTON_CANCEL')}
          className='h-[44px] w-[103px]'
        />
        <LiliButton
          id='invoiceHub-markAsPaid-recordAPayment'
          testId='invoiceHub-markAsPaid-recordAPayment'
          onClick={handleSubmit}
          title={t('COMPONENTS.MARK_AS_PAID.BUTTON_RECORD')}
          className='h-[44px] w-[177px] ml-[12px]'
        />
      </div>
    </div>
  );
};

export default MarkBillAsPaid;
